// Video catalog content shim.
// Loads + validates youtube.json (auto-generated YouTube API data) and
// video-groups.json (editorial overlay). Exposes typed, normalised videos
// + ordered groups.

import rawVideos from './data/youtube.json';
import rawGroups from './data/video-groups.json';
import { buildCatalog, groupVideos } from '@lib/adapters/youtube-catalog';
import type { Video } from '@lib/schemas/youtube';

const catalog = buildCatalog(rawVideos, rawGroups);

export const allVideos: ReadonlyArray<Video> = catalog.videos;
export const videoGroups = groupVideos(catalog.videos, catalog.groups);
export const videoGroupsMap = catalog.groups;
